import { Link, useNavigate } from "react-router-dom";
import { useContext, useState } from "react";
import { AuthContext } from "../contexts/AuthContext";

const Navbar = () => {
  const { token, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const handleLogout = () => {
    logout();
    navigate("/login");
    setDropdownVisible(false); // ✅ Close dropdown after logout
  };

  const toggleDropdown = () => setDropdownVisible(!dropdownVisible);

  return (
    <nav className="bg-white shadow p-4 flex justify-between items-center">
      {/* Logo */}
      <div className="flex items-center">
        <Link to="/">
          <img
            src="/logo.png"
            alt="Pair Lingo Logo"
            className="h-12 w-auto"
          />
        </Link>
      </div>

      {/* Navigation Links */}
      <div className="space-x-4 relative">
        <Link to="/">Home</Link>
        {token ? (
          <>
            <Link to="/users">Users</Link>
            <Link to="/profile">Profile</Link>
            <Link to="/requests">Requests</Link>
            <Link to="/support">Support</Link>

            {/* Profile Icon with Dropdown */}
            <div className="relative inline-block text-left">
              <button onClick={toggleDropdown} className="w-10 h-10 rounded-full bg-indigo-600 text-white flex items-center justify-center">
                👤
              </button>
              {dropdownVisible && (
                <div className="absolute right-0 mt-2 w-40 bg-white rounded-md shadow-lg z-10">
                  <Link
                    to="/profile-info"
                    className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    onClick={() => setDropdownVisible(false)}
                  >
                    Profile Information
                  </Link>
                  <button
                    onClick={handleLogout}
                    className="block w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-gray-100"
                  >
                    Logout
                  </button>
                </div>
              )}
            </div>
          </>
        ) : (
          <>
            <Link to="/login">Login</Link>
            <Link to="/register">Register</Link>
          </>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
